import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

function ServiceBenefitsAdd() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(id ? true : false);
    const [uploadingLogos, setUploadingLogos] = useState(false);

    const [formData, setFormData] = useState({
        logosSection: {
            name: '',
            logoUrl: '',
            altText: 'Service Logo',
            order: 1
        },
        circleOneBenefits: {
            serviceName: '',
            logoUrl: '',
            title: '',
            description: '',
            order: 1,
            isActive: true
        },
        coreMemberBenefits: {
            serviceName: '',
            logoUrl: '',
            title: '',
            description: '',
            order: 1,
            isActive: true
        },
        status: 'active',
        metadata: {
            version: '1.0',
            notes: 'Initial benefits configuration'
        }
    });

    const [logoFiles, setLogoFiles] = useState({
        logosSection: null,
        circleOneBenefits: null,
        coreMemberBenefits: null
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (id) {
            fetchBenefitDetails();
        }
    }, [id]);

    const fetchBenefitDetails = async () => {
        try {
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/membership/benefits/${id}`
            );
            const data = await res.json();

            if (data.status === 'success') {
                setFormData(data.data);
            } else {
                toast.error('Failed to fetch benefit details');
            }
        } catch (error) {
            console.error('Error fetching benefit:', error);
            toast.error('Error fetching benefit details');
        } finally {
            setLoading(false);
        }
    };

    const uploadImageToS3 = async (file) => {
        try {
            const payload = {
                fileName: file.name,
                fileType: file.type,
                folder: 'benefits/'
            };

            const res = await authManager.authenticatedFetch(
                `${Base_Url}/shopping/brands/upload/presign`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }
            );

            const data = await res.json();

            if (!res.ok || !data.presignedUrl || !data.fileUrl) {
                throw new Error(data.message || 'Failed to generate presigned URL');
            }

            const { presignedUrl, fileUrl } = data;

            const upload = await fetch(presignedUrl, {
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                body: file
            });

            if (!upload.ok) throw new Error('Image upload to S3 failed');

            return fileUrl;
        } catch (err) {
            console.error('Image upload error:', err);
            throw err;
        }
    };

    const handleLogoChange = (e, section) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFiles(prev => ({
                ...prev,
                [section]: file
            }));
            setFormData(prev => ({
                ...prev,
                [section]: {
                    ...prev[section],
                    logoUrl: URL.createObjectURL(file)
                }
            }));
        }
    };

    const handleInputChange = (e, section, field) => {
        const { value } = e.target;
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleMetadataChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            metadata: {
                ...prev.metadata,
                [name]: value
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setUploadingLogos(true);

            let finalFormData = { ...formData };

            // Upload logos if changed
            for (const [section, file] of Object.entries(logoFiles)) {
                if (file) {
                    const logoUrl = await uploadImageToS3(file);
                    finalFormData[section].logoUrl = logoUrl;
                }
            }

            const url = id
                ? `${Base_Url}/membership/benefits/${id}`
                : `${Base_Url}/membership/benefits/create`;

            const method = id ? 'PUT' : 'POST';

            const res = await authManager.authenticatedFetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(finalFormData)
            });

            const data = await res.json();

            if (data.status === 'success') {
                toast.success(id ? 'Benefit updated successfully!' : 'Benefit created successfully!');
                setTimeout(() => navigate('/serviceBenefits'), 3000);
            } else {
                toast.error(data.message || 'Operation failed');
            }
        } catch (err) {
            console.error('Error saving benefit:', err);
            toast.error('Error saving benefit');
        } finally {
            setUploadingLogos(false);
        }
    };
    return (
        <>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6 col-sm-6">
                            <h1 className="m-0 txt_lft"> {id ? 'Edit' : 'Add'} Service Benefit</h1>
                        </div>
                        <div className="col-6 col-sm-6">
                            <ol className="breadcrumb justify-content-end">
                                <li className="breadcrumb-item">
                                    <Link to="/serviceBenefits">
                                        <i className="fa-solid fa-arrow-left-long" /> Back
                                    </Link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    {/* form start */}
                                    {loading ? (
                                        <div className="card-body text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <form className="form-horizontal" onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                {/* Main Name Field */}
                                                <div className="form-group row mb-5">
                                                    <label className="col-12 col-md-4 col-form-label">Name</label>
                                                    <div className="col-12 col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={formData.logosSection.name}
                                                            onChange={(e) => handleInputChange(e, 'logosSection', 'name')}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Logos Section */}
                                                <div>
                                                    <h5 className="f_blue pb-3 mb-3 border-bottom">Logos</h5>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Logo (White)<br /><span className="f_sz12 f_grey2">(Will be displayed in Home Page)</span></label>
                                                        <div className="col-12 col-md-8">
                                                            <div className="position-relative">
                                                                <div className="s_profileupld">
                                                                    <label className="btn-bs-file btn-blue">
                                                                        Add Logo
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(e) => handleLogoChange(e, 'logosSection')}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-row flex-wrap pt-20 pb-15">
                                                                {formData.logosSection.logoUrl && (
                                                                    <div className="community_imgwrapper m-3">
                                                                        <div className="community_icon">
                                                                            <img src={formData.logosSection.logoUrl} alt="Logo" />
                                                                        </div>
                                                                        <div className="community_delicon">
                                                                            <i
                                                                                className="fa-solid fa-circle-xmark f_red"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => setFormData(prev => ({
                                                                                    ...prev,
                                                                                    logosSection: { ...prev.logosSection, logoUrl: '' }
                                                                                }))}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* CircleOne Benefits Section */}
                                                <div>
                                                    <h5 className="f_blue pb-3 mb-3 border-bottom">CircleOne Benefits <span className="f_sz12 f_grey2">(Will be displayed in Home Page)</span></h5>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Title</label>
                                                        <div className="col-12 col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={formData.circleOneBenefits.serviceName}
                                                                onChange={(e) => handleInputChange(e, 'circleOneBenefits', 'serviceName')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Sub Title</label>
                                                        <div className="col-12 col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={formData.circleOneBenefits.title}
                                                                onChange={(e) => handleInputChange(e, 'circleOneBenefits', 'title')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Description</label>
                                                        <div className="col-12 col-md-8">
                                                            <textarea
                                                                className="form-control txtarea_hgt"
                                                                value={formData.circleOneBenefits.description}
                                                                onChange={(e) => handleInputChange(e, 'circleOneBenefits', 'description')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Logo (Colored)</label>
                                                        <div className="col-12 col-md-8">
                                                            <div className="position-relative">
                                                                <div className="s_profileupld">
                                                                    <label className="btn-bs-file btn-blue">
                                                                        Add Logo
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(e) => handleLogoChange(e, 'circleOneBenefits')}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-row flex-wrap pt-20 pb-15">
                                                                {formData.circleOneBenefits.logoUrl && (
                                                                    <div className="community_imgwrapper m-3">
                                                                        <div className="community_icon">
                                                                            <img src={formData.circleOneBenefits.logoUrl} alt="Logo" />
                                                                        </div>
                                                                        <div className="community_delicon">
                                                                            <i
                                                                                className="fa-solid fa-circle-xmark f_red"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => setFormData(prev => ({
                                                                                    ...prev,
                                                                                    circleOneBenefits: { ...prev.circleOneBenefits, logoUrl: '' }
                                                                                }))}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Core Member Benefits Section */}
                                                <div>
                                                    <h5 className="f_blue pb-3 mb-3 border-bottom">Core Benefits <span className="f_sz12 f_grey2">(Will be displayed in Benefits Page)</span></h5>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Title</label>
                                                        <div className="col-12 col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={formData.coreMemberBenefits.serviceName}
                                                                onChange={(e) => handleInputChange(e, 'coreMemberBenefits', 'serviceName')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Sub Title</label>
                                                        <div className="col-12 col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={formData.coreMemberBenefits.title}
                                                                onChange={(e) => handleInputChange(e, 'coreMemberBenefits', 'title')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Description</label>
                                                        <div className="col-12 col-md-8">
                                                            <textarea
                                                                className="form-control txtarea_hgt"
                                                                value={formData.coreMemberBenefits.description}
                                                                onChange={(e) => handleInputChange(e, 'coreMemberBenefits', 'description')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-12 col-md-4 col-form-label">Logo (Colored)</label>
                                                        <div className="col-12 col-md-8">
                                                            <div className="position-relative">
                                                                <div className="s_profileupld">
                                                                    <label className="btn-bs-file btn-blue">
                                                                        Add Logo
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(e) => handleLogoChange(e, 'coreMemberBenefits')}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-row flex-wrap pt-20 pb-15">
                                                                {formData.coreMemberBenefits.logoUrl && (
                                                                    <div className="community_imgwrapper m-3">
                                                                        <div className="community_icon">
                                                                            <img src={formData.coreMemberBenefits.logoUrl} alt="Logo" />
                                                                        </div>
                                                                        <div className="community_delicon">
                                                                            <i
                                                                                className="fa-solid fa-circle-xmark f_red"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => setFormData(prev => ({
                                                                                    ...prev,
                                                                                    coreMemberBenefits: { ...prev.coreMemberBenefits, logoUrl: '' }
                                                                                }))}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-footer text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-blue"
                                                    disabled={uploadingLogos}
                                                >
                                                    {uploadingLogos ? 'Uploading...' : (id ? 'Update' : 'Add')}
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ServiceBenefitsAdd